import React from 'react';
import Select from 'react-select';
import classNames from 'classnames';
import { isArrayLength } from '../../../util/genericHelpers';

import css from './BookingDatesForm.module.css';

const customStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: '#fff',
    border: 'solid 1px #EBEBEB',
    boxShadow: 'none',
    color: '#484848',
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '100%',
    letterSpacing: '-0.04em',
    height: 'fit-content',
    paddingLeft: '10px',
    paddingRight: '10px',
    minHeight: '45px',
    margin: '0px',
    fontWeight: '400',
    position: 'relative',
  }),

  dropdownIndicator: (base, state) => ({
    ...base,
    paddingRight: 0,
    transition: 'all .2s ease',
    transform: state.isFocused ? 'rotate(180deg)' : null,
  }),
  indicatorSeparator: styles => ({ display: 'none' }),
  valueContainer: (base, state) => ({
    ...base,
    padding: 0,
    height: 'fit-content',
    margin: 0,
  }),
  input: (base, state) => ({
    ...base,
    padding: 0,
    height: '45px',
    minHeight: 'auto',
    margin: 0,
    color: '#484848',
  }),
  option: (styles, { isFocused, isDisabled, isSelected }) => ({
    ...styles,
    color: '#484848',
    padding: '6px 10px',
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '100%',
    letterSpacing: '-0.04em',
    backgroundColor: isDisabled ? null : isFocused ? '#F0EDF6' : isSelected ? '#FFF' : null,
  }),
  singleValue: (styles, { isFocused, isDisabled, isSelected }) => ({
    ...styles,
    color: '#4a4a4a',
    lineHeight: '118%',
    fontWeight: '500',
  }),
  menuPortal: base => ({ ...base, position: 'absolute', top: '0', left: '0' }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    marginTop: 0,
    backgroundColor: '#fff',
    color: '#484848',
  }),
  menuList: base => ({
    ...base,
    padding: '6px 10px',
    backgroundColor: '#fff',
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '100%',
    letterSpacing: '-0.04em',
    color: '#484848',
  }),
  placeholder: base => ({
    ...base,
    padding: '6px 0px',
    backgroundColor: '#fff',
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '100%',
    letterSpacing: '-0.04em',
    color: '#b2b2b2',
    position: 'relative',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
  }),
  dropdownIndicator: base => ({
    ...base,
    color: '#484848',
  }),
};

function RenderAddons(props) {
  const { addons, selectedAddons, setSelectedAddons, form, availableOptionsLabel } = props;

  // Check if addons array is valid and has length
  if (!isArrayLength(addons)) {
    return null;
  }

  // Map addons to React Select options
  const options = addons.map(addon => ({
    id: addon.id,
    price: parseFloat(addon.price).toFixed(2), // Ensure price is in decimal format
    value: addon.id,
    name: addon.name,
    label: `${addon.name} - $${parseFloat(addon.price).toFixed(2)}`, // Format price
  }));

  // Map selected addon ids to React Select options
  const selectedOptions = selectedAddons.map(selectedAdd => {
    const addon = addons.find(addon => addon.id === selectedAdd.id);
    return {
      id: addon.id,
      price: parseFloat(addon.price).toFixed(2), // Ensure price is in decimal format
      name: addon.name,
      value: addon.id,
      label: `${addon.name} - $${parseFloat(addon.price).toFixed(2)}`, // Format price
    };
  });

  // Handle change for React Select
  const handleChange = selectedOptions => {
    const selectedIds = selectedOptions ? selectedOptions : [];
    setSelectedAddons(selectedIds);
    form.change('addons', selectedIds);
  };

  return (
    <div className={css.addons}>
      <h4>{availableOptionsLabel}</h4>
      <Select
        isMulti
        styles={customStyles}
        value={selectedOptions}
        onChange={handleChange}
        options={options}
        className={classNames(css.addonsBlock, {
          [css.activeBlock]: selectedOptions.length > 0,
        })}
        classNamePrefix="select"
      />
    </div>
  );
}

export default RenderAddons;
